<template>
  <div class="u-wrap">
    <div class="heard">
      <van-tabs v-model="currentTab" @change="change" color="#3E78F7" line-width="70px">
        <van-tab v-for="(title, index) in tabList" :key="index" :title="title"></van-tab>
      </van-tabs>
    </div>
    <div class="u-content-wrap">
      <van-empty v-if="dataList.length == 0" style="width:100%" description="暂无数据" />
      <van-pull-refresh v-else v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" offset="20" :finished="finished" finished-text="" @load="onLoad">
          <div style="width: 100vw">
            <qzzx-card :list="dataList"></qzzx-card>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import qzzxCard from '@/views/common/qzzx-card.vue'
import { getAction, postAction ,postParam } from '@/api/manage'
export default {
  components: {
    qzzxCard,
  },
  data() {
    return {
      currentTab: 0,
      tabList: ['全部', '未回复', '已回复'],
      typeArr:['','01','02'],
      dataList: [],
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      pageNo:0,
      type:'02',
    }
  },
  created(){
    this.onRefresh();
  },
  computed: {},
  methods: {
    change(index) {
       this.current = index;
       let i = Number(index);
       this.clzt = this.typeArr[i];
       this.onRefresh();
    },
      getData() {
      let openId = this.$store.getters.openId;
      let params = {type:this.type,pageNo:this.pageNo,clzt:this.clzt,openId:openId};
      getAction('/zhshj/seekhelp/page',params)
      .then((res) => {
           if (this.refreshing) {
              this.dataList = [];
              this.refreshing = false;
          }
        let list = res.result.records;
        this.dataList = this.dataList.concat(list);
         this.loading = false;
        if(res.result.pages <= this.pageNo){
           this.finished = true;
        }
      })
    },
      onLoad() {
        this.pageNo++
        this.getData();
   
    },
   onRefresh() {
      // 清空列表数据
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.pageNo = 0;
      this.refreshing  = true;
      this.onLoad();
    },
     	convert(list){
			var newList = list.map(val => {
				  var imgList = [];
				  var videoList = [];
				  var audioList = [];
				if(val.imgUrl){
           let arr = val.imgUrl.split(',');
					for(let item of arr){
						if(matchType(item)=="image"){
							imgList.push(item)
						}else if(matchType(item)=="video"){
							videoList.push(item)
						}else if(matchType(item)=="radio"){
							audioList.push(item)
						}
					}
				}
				val.imgList = imgList;
				val.videoList = videoList;
				val.audioList = audioList;
				return val;
			})	
			return newList;	
			},
  },
}
</script>

<style lang="less" scoped>
.u-wrap {
  height: 100vh;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding-top: 44px;
  background-color: #f5f5f5;
}
.heard {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  z-index: 1;
}
.u-content-wrap {
  flex: 1;
  display: flex;
}
</style>
